import 'babel-polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import TacDialogConnect from './components/Tac/TacDialogConnect';
import Dashboard from './components/Dashboard/DashboardConnect';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import './index.css';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import appReducer from './reducers';
import DevTools from './components/DevTools';
import { Router, Route, IndexRoute, Link, browserHistory } from 'react-router'; // TODO: Once we got a chance to config the delivery server (even with nginx) we should change this to browserHistory to have clean URLs and also to make serverside rendering possible
import {
	syncHistoryWithStore,
	// routerMiddleware
} from 'react-router-redux'; // routerReducer is added in the appReducer.js
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import {redLaunch, fetchAzuProvRela, toggleFSLoading} from './actions';
import NAdmin from './components/Tac/NAdmin';
import UsersList from './components/User/UsersList';
import AddUser from './components/User/AddUser';


const loggerMiddleware = createLogger()
if(process.env.NODE_ENV == 'development') window.env = process.env.NODE_ENV; //This is just to have the env defined outside of react/redux scope for debugging purposes
const enhancers = compose( // This is the same compose as found in Underscore or lodash, it will compose all our store enhancers in to one
    applyMiddleware(
		thunkMiddleware // dispatch() functions
		// loggerMiddleware, // logs actions
		// routerMiddleware
	),
    DevTools.instrument() //TODO: We need to implement a mechanism so dev-tools will be added only in DEV env. (maybe using envify?) <-- check the redux-dev-tools docs
    // persistState(getDebugSessionKey())
);
const initialState = {};
let store = createStore(
	appReducer,
	initialState,
	enhancers
	);

const history = syncHistoryWithStore(browserHistory, store) // Create an enhanced history that syncs navigation events with the store

window.addEventListener("message", function(event) { // Here we are listening for the atlas load event
  if (event.source != window) return;
  if (event.data.type && (event.data.type == "FROM_ATLAS")) {
    console.log("WE RECEIVED THE MESSAGE FROM ATLAS: " + event.data.text);
    if(event.data.isAtlasReady){
		store.dispatch(redLaunch({isAtlasLaunched: true, currentAccountAlias: event.data.currentAccountAlias}))
	}
  }
}, false);


store.dispatch(toggleFSLoading({showLoadingFS:true, loadingFSText1: '.:ATLAS:.', loadingFSText2: 'Atlas Initialization..'}))

ReactDOM.render(
  <Provider store={store}>
	  <Router history={history}>
	    <Route path="/" component={App}>
	        {/*<IndexRoute component={Home}/>*/}
	        <Route path="TermsAndConditions" component={TacDialogConnect}/>
	        <Route path="DashBoard" component={Dashboard}>
				<Route path="default" components={{UsersList}}></Route>
			</Route>
			<Route path="AddUser" component={AddUser}></Route>
	        {/*Child components can be here and they can have more nested children too but parrent component */}
			<Route path="/NonAdminUser" component={NAdmin}/>
	    </Route>
	  </Router>
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/